module.exports = __webpack_public_path__ + "img/apply-primar-prof.52130718.svg";